<template>
  <div>
    <file-manager-progress :showProgress="showProgress" :variant="variant" />
    <input :disabled="disabled" id="file-input" type="file" ref="fileInput" :multiple="multiple" @change="handleFileChange" :accept="allowedFormats" />
    <button :disabled="disabled" :hidden="hidden" @click="uploadFiles" :class="['btn btn-sm', 'btn-' + variant]">{{ $t("file-manager.upload") }}</button>
  </div>
</template>

<script>
import FileManagerProgress from "./file-manager-progress.vue";
export default {
  props: {
    submitAction: {
      required: false,
      type: Function,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    variant: {
      required: false,
      type: String,
      default: "success",
    },
    showProgress: {
      required: false,
      type: String,
      default: "All", //All,Upload,Download
    },
    allowedFormats: {
      required: true,
      type: Array,
    },
    maxFileLength: {
      required: false,
      type: Number,
      default: 5,
    },
    maxFileSize: {
      required: true,
      type: Number,
    },
    multiple: {
      required: false,
      type: Boolean,
      default: false,
    },
    targetUrl: {
      required: false,
      type: String,
      default: "/file-manager/upload",
    },
    payload: {
      required: false,
    },

    hidden: {
      required: false,
      default: false,
    },
  },
  components: { FileManagerProgress },

  data() {
    return {
      selectedFiles: [],
      //allowedFormats: ["image/jpeg", "image/png", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
    };
  },
  watch: {
    sutmitAction() {
      this.uploadFiles();
    },
  },
  computed: {
    isUploading() {
      return this.$store.getters["fileManager/isUploading"];
    },
  },
  mounted() {},
  methods: {
    uploadFiles() {
      const files = this.$refs.fileInput.files;
      for (let i = 0; i < files.length; i++) {
        this.upload(files[i]);
      }

      this.$refs.fileInput.value = null;
    },
    async upload(file) {
      if (!this.allowedFormats.find((allowed) => new RegExp(allowed.replace("*", "(.*)")).test(file.type))) {
        // Geçersiz dosya formatı
        this.$handleHttpErrorByStatusCode(null, { customMessage: this.$t("file-manager.unsupported-file-format") });
        return;
      }
      if (file.size > this.maxFileSize) {
        this.$handleHttpErrorByStatusCode(null, { customMessage: this.$t("file-manager.file-size-limit-exceed") });

        return;
      }

      const response = await this.$store.dispatch("fileManager/uploadFile", { targetUrl: this.targetUrl, payload: this.payload, file });
      this.$emit("response", response);
    },
    handleFileChange(event) {
      const files = event.target.files;
      if (files.length > this.maxFileLength) {
        this.$handleHttpErrorByStatusCode(event, { customMessage: this.$t("file-manager.file-length-exceed", { count: this.maxFileLength }) });
        this.$refs.fileInput.value = null;
      } else {
        this.selectedFiles = files;
      }
    },
  },
};
</script>

<style scoped></style>
